export default __webpack_public_path__ + "static/media/69a4b363310379dcc0dddf957bd7922d.svg";